var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "fullscreen_exit_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fullscreen_exit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 23h2c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.968.968 0 0111 25H8a.967.967 0 01-.713-.288A.968.968 0 017 24v-3c0-.283.096-.52.287-.712A.967.967 0 018 20c.283 0 .52.096.713.288.191.191.287.429.287.712v2zm14 0v-2c0-.283.096-.52.288-.712A.968.968 0 0124 20c.283 0 .52.096.712.288.192.191.288.429.288.712v3c0 .283-.096.52-.288.712A.968.968 0 0124 25h-3a.968.968 0 01-.712-.288A.968.968 0 0120 24c0-.283.096-.52.288-.712A.968.968 0 0121 23h2zM9 9v2c0 .283-.096.52-.287.713A.967.967 0 018 12a.967.967 0 01-.713-.287A.968.968 0 017 11V8c0-.283.096-.52.287-.713A.968.968 0 018 7h3c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.713A.968.968 0 0111 9H9zm14 0h-2a.968.968 0 01-.712-.287A.967.967 0 0120 8c0-.283.096-.52.288-.713A.968.968 0 0121 7h3c.283 0 .52.096.712.287.192.192.288.43.288.713v3c0 .283-.096.52-.288.713A.968.968 0 0124 12a.968.968 0 01-.712-.287A.968.968 0 0123 11V9z",
    fill: "#fff"
  }))));
}
export default SvgFullscreenExit;